export const MAP_PLACE_FIELDS = `provider providerPlaceId displayName formattedAddress mapUrl categories rating ratingCount priceRange location {lat lng} geo {type coordinates}`;
